import React from 'react';
import { useApp } from '../context/AppContext';

// Small notification that slides in at the bottom of the screen.
export default function Toast() {
  const { toast } = useApp();
  return <div className={`toast ${toast ? 'show' : ''}`}>{toast}</div>;
}
